import MainContainer from '../../../components/ui_components/MainContainer';
import { useLoaderData, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import colors from '../../../styles/colors';

const Wrapper = styled.div`
    width: 80%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    margin: 0 auto;

    & h1, h2, h3, h4, h5, h6 {
        margin: 0;
        padding: 0;
        font-family: CameronSansMedium, CameronSansLight, Trebuchet MS, Arial, Helvetica, Verdana, Tahoma, sans-serif;
    }
`;

const ContainerInfoBelt = styled.div`
    width: 100%;
    height: 120px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: ${colors.bgColorBlack2};
    border-radius: 8px;
    padding: 10px;
    border: 2px solid ${colors.bgColorBordeaux};
    margin-bottom: 10px;

    & .belt-name {
        font-size: 20px;
        font-weight: 500;
        color: white;
    }

    & .belt-img {
        width: 100%;
        max-height: 80px;
        object-fit: contain;
        object-position: center;
    }
`;

const BoxChampions = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    row-gap: 5px;
`;

const SingleChampionRow = styled.div`
    height: 50px;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border: 2px solid black;
    background-color: ${colors.bgColorBordeaux};
    border-radius: 5px;
    padding: 0 10px;

    &:hover {
        cursor: pointer;
        background-color: ${colors.bgColorBordeaux};
    }
`;

const LeftSize = styled.div`
    width: 25%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    & img.wrestler-img {
        width: 50%;
        max-width: 40px;
        height: 40px;
        object-fit: cover;
        object-position: top;
        border: 1px solid white;
    }
`;

const RightSize = styled.div`
    width: calc(100% - 25%);
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    & .top-size,
    & .bottom-size {
        width: 100%;
        height: 15px;
        display: flex;
        align-items: center;
        justify-content: center;

        & h6 {
            font-size: 6px;
            font-weight: 500;
            color: white;
            text-align: center;
            margin: 0;
        }
    }

    & .center-size-info-row {
        width: 100%;
        height: calc(100% - 30px);
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        & .name-champion {
            font-size: 10px;
            font-weight: 500;
            color: white;
            text-align: center;
            margin: 0;
        }
    }
`;

const TagBeltInfoMobile = () => {
    const beltData = (useLoaderData() as any)?.data;
    const navigate = useNavigate();

    const navigateToPpv = (ppvId: string, ppvName: string): void => {
        navigate(`/ppv/specific/i_${ppvId}_d_${ppvName}`);
    };

    return (
        <MainContainer className='single-belt-info-mobile-container' isMobile={true}>
            <Wrapper className='wrapper-single-belt-info-mobile'>

                <ContainerInfoBelt className='container-info-belt'>
                    <h1 className='belt-name'>{beltData.name}</h1>
                    <img className='belt-img' src={process.env.REACT_APP_STORAGE_URL + beltData.img_path} alt={beltData.name} />
                </ContainerInfoBelt>

                <BoxChampions className='box-champions'>
                    {beltData.listWinners.map((infoSingleWin, index) => (
                        <SingleChampionRow 
                         className='single-champion-row' 
                         key={index} 
                        //  onclick funziona solo se minuscolo(wrestler.ppv_name è diverso da fear, tap out o lite 
                         onClick={() => {
                            if (infoSingleWin.ppv_name.toLowerCase() !== 'fear' && infoSingleWin.ppv_name.toLowerCase() !== 'tap out' && infoSingleWin.ppv_name.toLowerCase() !== 'lite') {
                                navigateToPpv(infoSingleWin.ppv_id, infoSingleWin.ppv_name);
                            }
                         }}
                        >
                            <LeftSize className='left-size'>
                                {infoSingleWin.winners.map((winner, index) => (
                                    winner.avatar_path ? (
                                        <img key={winner.id ?? index} className='wrestler-img' src={process.env.REACT_APP_STORAGE_URL + winner.avatar_path} alt={winner.name} />
                                    ) : (
                                        <div key={winner.id ?? index} className='wrestler-img' />
                                    )
                                ))}
                                
                            </LeftSize>

                            <RightSize className='right-size'>
                                <div className='top-size'>
                                    <h6 className='text-name-ppv'>{infoSingleWin.ppv_name}</h6>
                                </div>

                                <div className='center-size-info-row'>
                                    {infoSingleWin.winners.map((winner, index) => (
                                        <h2 key={winner.id ?? index} className='name-champion'>{winner.name ? winner.name + (index < infoSingleWin.winners.length - 1 ? ' & ' : '') : 'VACANTE'}</h2>
                                    ))}
                                </div>

                                <div className='bottom-size'>
                                    <h6 className='text-date-ppv'>{infoSingleWin.date_win}</h6>
                                </div>

                            </RightSize>
                        </SingleChampionRow>
                    ))}
                </BoxChampions>
            </Wrapper>
        </MainContainer>
    );
};

export default TagBeltInfoMobile;